import { useMemo } from 'react'
import { personName } from 'Data/format.js'

/** @type {import('Simple/types.js').useDataTransform} */
export default function useDataTransform(props, data) {
  return useMemo(() => {
    if (!data) return data

    let payment_accounts = data.payment_accounts
      // only show existing payors
      .filter(i => typeof i.payment_account_id === 'number')
      .map(i => {
        if (typeof i.insured_id === 'number') {
          return {
            // include insured_id in case the insurance subscription if for the same insurance carrier
            // but a different subscription member (e.g. both mom and dad both have an insurance with the same insurance carrier)
            id: `${i.payment_account_id}--${i.insured_id}`,
            text: `${i.insurance_company.carrier_name} (Group/Plan: ${
              i.insurance_plan.number
            }) - ${personName(i.payor)}`,
            account_type: 'InsurancePaymentAccount',
            insured_id: i.insured_id,
            payment_account_id: i.payment_account_id,
          }
        } else {
          return {
            id: `${i.payment_account_id}`,
            text: `${personName(i.payor)}`,
            account_type: 'PersonPaymentAccount',
            payment_account_id: i.payment_account_id,
          }
        }
      })

    payment_accounts.sort((a, b) => {
      // Sort by account_type first (PersonPaymentAccount before InsurancePaymentAccount)
      if (a.account_type !== b.account_type) {
        return a.account_type === 'PersonPaymentAccount' ? -1 : 1
      }
      // Then sort by name
      return a.text.localeCompare(b.text)
    })

    return payment_accounts
  }, [data])
}
